const BRANDS = [
  { brand: "Andere", category: 1, index: 0 },
  { brand: "Airstreeem", category: 2, index: 1 },
  { brand: "Argon", category: 1, index: 2 },
  { brand: "Babboe", category: 1, index: 3 },
  { brand: "Basso", category: 1, index: 4 },
  { brand: "Batavus", category: 2, index: 5 },
  { brand: "Bellini", category: 2, index: 6 },
  { brand: "Bianchi", category: 1, index: 7 },
  { brand: "BMC", category: 1, index: 8 },
  { brand: "Bocas", category: 2, index: 9 },
  { brand: "Bombtrack", category: 1, index: 10 },
  { brand: "Boomer", category: 2, index: 11 },
  { brand: "Böttcher", category: 1, index: 12 },
  { brand: "Brompton", category: 1, index: 13 },
  { brand: "Bulls", category: 1, index: 14 },
  { brand: "Cannondale", category: 1, index: 15 },
  { brand: "Canyon", category: 1, index: 16 },
  { brand: "Centurion", category: 2, index: 17 },
  { brand: "Cervélo", category: 1, index: 18 },
  { brand: "Cinelli", category: 1, index: 19 },
  { brand: "Colnago", category: 1, index: 20 },
  { brand: "Compel", category: 2, index: 21 },
  { brand: "Conway", category: 2, index: 22 },
  { brand: "Corratec", category: 2, index: 23 },
  { brand: "Cresta", category: 1, index: 24 },
  { brand: "Cube", category: 1, index: 25 },
  { brand: "Dancelli", category: 2, index: 26 },
  { brand: "Dartmoor", category: 1, index: 27 },
  { brand: "De Rosa", category: 1, index: 28 },
  { brand: "DIamant", category: 1, index: 29 },
  { brand: "Electra", category: 2, index: 30 },
  { brand: "Fausto Coppi", category: 1, index: 31 },
  { brand: "Fischer", category: 2, index: 32 },
  { brand: "Focus", category: 2, index: 33 },
  { brand: "Frogbikes", category: 1, index: 34 },
  { brand: "Fuji", category: 1, index: 35 },
  { brand: "Gazelle", category: 1, index: 36 },
  { brand: "Geero", category: 1, index: 37 },
  { brand: "Genesis", category: 2, index: 38 },
  { brand: "Ghost", category: 1, index: 39 },
  { brand: "Giant", category: 1, index: 40 },
  { brand: "Grecos", category: 2, index: 41 },
  { brand: "Gudereit", category: 2, index: 42 },
  { brand: "Haibike", category: 1, index: 43 },
  { brand: "Hase Bikes", category: 2, index: 44 },
  { brand: "Hercules", category: 2, index: 45 },
  { brand: "HNF-Nicolai", category: 1, index: 46 },
  { brand: "Intec", category: 1, index: 47 },
  { brand: "Kalkhoff", category: 2, index: 48 },
  { brand: "Kettler", category: 2, index: 49 },
  { brand: "Kreidler", category: 2, index: 50 },
  { brand: "KTM", category: 1, index: 51 },
  { brand: "Lapierre", category: 1, index: 52 },
  { brand: "Marin", category: 1, index: 53 },
  { brand: "Mondraker", category: 1, index: 54 },
  { brand: "Mongoose", category: 1, index: 55 },
  { brand: "NCM", category: 2, index: 56 },
  { brand: "NS Bikes", category: 1, index: 57 },
  { brand: "Orbea", category: 1, index: 58 },
  { brand: "Ortler", category: 2, index: 59 },
  { brand: "Panasonic", category: 2, index: 60 },
  { brand: "Passat", category: 2, index: 61 },
  { brand: "Pegasus", category: 2, index: 62 },
  { brand: "Peugeot", category: 2, index: 63 },
  { brand: "Pinarello", category: 1, index: 64 },
  { brand: "Propain", category: 1, index: 65 },
  { brand: "Prophete", category: 2, index: 66 },
  { brand: "Puky", category: 2, index: 67 },
  { brand: "Pyro Bikes", category: 1, index: 68 },
  { brand: "Rabeneick", category: 2, index: 69 },
  { brand: "Radon", category: 2, index: 70 },
  { brand: "Raleigh", category: 1, index: 71 },
  { brand: "Ribble", category: 2, index: 72 },
  { brand: "Ridgeback", category: 1, index: 73 },
  { brand: "Riese & Müller (R&M)", category: 1, index: 74 },
  { brand: "Riese und Müller", category: 1, index: 75 },
  { brand: "Ritchey", category: 2, index: 76 },
  { brand: "Rockmachine", category: 2, index: 77 },
  { brand: "Rondo", category: 2, index: 78 },
  { brand: "Rose", category: 1, index: 79 },
  { brand: "Rotwild", category: 1, index: 80 },
  { brand: "Ruff Cycles", category: 1, index: 81 },
  { brand: "Santa Cruz", category: 1, index: 82 },
  { brand: "Schauff", category: 2, index: 83 },
  { brand: "Schindelhauer", category: 1, index: 84 },
  { brand: "Schwinn", category: 1, index: 85 },
  { brand: "Scool", category: 2, index: 86 },
  { brand: "Scott", category: 1, index: 87 },
  { brand: "Simplon", category: 1, index: 88 },
  { brand: "Sinus", category: 2, index: 89 },
  { brand: "Sparta", category: 2, index: 90 },
  { brand: "Specialized", category: 1, index: 91 },
  { brand: "Staiger", category: 2, index: 92 },
  { brand: "Stevens", category: 1, index: 93 },
  { brand: "Stoewer", category: 1, index: 94 },
  { brand: "Storck", category: 1, index: 95 },
  { brand: "Surly", category: 1, index: 96 },
  { brand: "Sushi Bikes", category: 2, index: 97 },
  { brand: "Tern", category: 1, index: 98 },
  { brand: "Torpedo", category: 1, index: 99 },
  { brand: "Transition", category: 1, index: 100 },
  { brand: "Trek", category: 1, index: 101 },
  { brand: "Univega", category: 2, index: 102 },
  { brand: "Urban Arrow", category: 1, index: 103 },
  { brand: "Urwahn", category: 1, index: 104 },
  { brand: "Van Moof", category: 1, index: 105 },
  { brand: "Velo de Ville", category: 1, index: 106 },
  { brand: "Victoria", category: 2, index: 107 },
  { brand: "vsf fahrradmanufaktur", category: 1, index: 108 },
  { brand: "Wilier", category: 1, index: 109 },
  { brand: "Winora", category: 1, index: 110 },
  { brand: "Woom", category: 1, index: 111 },
  { brand: "YT", category: 1, index: 112 },
];

export default BRANDS;
